import CreateProduct from './CreateProduct';
export default CreateProduct;
